import {RightDiet} from './app/RightDiet.js'
window.RightDiet = RightDiet;